<template>
  <Cascader
    clearable
    filterable
    :change-on-select="changeOnSelect"
    :value="localValue"
    :placeholder="placeholder"
    :data="addressList"
    :load-data="loadList"
    :disabled="disabled"
    @on-change="change"
  ></Cascader>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: 3,
      validator: function(value) {
        return [1, 2, 3, 4].indexOf(value) !== -1
      }
    }
  },
  data() {
    return {
      changeOnSelect: true,
      addressList: [],
      localValue: [],
      valueList: []
    }
  },
  watch: {
    value(val) {
      console.log('AutoConsole: value -> val', val)
      if (val.toString() !== this.valueList.toString()) {
        this.valueList = val.filter(Boolean)
        if (this.valueList.length) {
          this.getRealAddr()
        } else {
          this.localValue = []
        }
      }
    }
  },
  methods: {
    loadList(item, callback) {
      if (!item || item.loading) {
        return
      }
      item.loading = true
      this.$http
        .get('/area/list', {
          params: {
            parentId: item.value
          }
        })
        .then(res => {
          for (let address of res.data) {
            let data = {
              value: address.id,
              label: address.name,
              children: []
            }
            if (address.level !== this.level && address.hasChild > 0) {
              data.loading = false
            }
            item.children.push(data)
          }
          item.loading = false

          if (callback) {
            callback()
          }
        })
    },
    change(value, selectedData) {
      this.$emit('on-change', value, selectedData)
    },
    getAddressItem(list, id) {
      let addrItem = null
      list.forEach((item, index) => {
        if (item.value === id) {
          addrItem = item
          return false
        }
      })
      return addrItem
    },
    getRealAddr() {
      this.addressList = []
      this.$http
        .get('/area/list', {
          params: {
            parentId: 1
          }
        })
        .then(res => {
          for (let address of res.data) {
            this.addressList.push({
              value: address.id,
              label: address.name,
              loading: false,
              children: []
            })
          }
          // 初始化值
          let localValue = []
          if (this.valueList) {
            this.valueList.forEach((item, index) => {
              if (item && item !== '') {
                localValue.push(item)
              } else {
                return false
              }
            })
          }
          // 遍历先初始化数据出来
          if (localValue.length <= 0) {
            return
          }
          let datas = this.addressList
          let index = 0
          let item = null
          let callback = () => {
            index = index + 1
            if (index < localValue.length - 1) {
              datas = item.children
              item = this.getAddressItem(datas, localValue[index])
              this.loadList(item, callback)
            } else {
              this.localValue = localValue
            }
          }
          if (index < localValue.length) {
            item = this.getAddressItem(datas, localValue[index])
            this.loadList(item, callback)
          }
        })
    }
  },
  created() {
    this.getRealAddr()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AddressSelect.vue